import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LayoutComponent } from "./modules/shared/components/layout/layout.component";
import { DashboardComponent } from "./modules/dashboard/dashboard.component";
import { dashboardAccessGuard } from "./modules/shared/services/dashboard-access.guard";
import { AddOrderComponent } from "./modules/order-management/components/add-order/add-order.component";
import { OrderDetailsComponent } from "./modules/order-management/components/order-details/order-details.component";
import { OrdersListComponent } from "./modules/order-management/components/orders-list/orders-list.component";
import { AddProductComponent } from "./modules/products/components/add-product/add-product.component";
import { ProductDetailsComponent } from "./modules/products/components/product-details/product-details.component";
import { ProductsListComponent } from "./modules/products/components/products-list/products-list.component";
import { ReportsListComponent } from "./modules/reports/components/reports-list/reports-list.component";
import { SitesListComponent } from "./modules/site-management/components/sites-list/sites-list.component";
import { SponsorsListComponent } from "./modules/sponsor-management/components/sponsors-list/sponsors-list.component";
import { AddTrialComponent } from "./modules/trials/components/add-trial/add-trial.component";

import { TrialDetailsComponent } from "./modules/trials/components/trial-details/trial-details.component";
import { TrialsListComponent } from "./modules/trials/components/trials-list/trials-list.component";
import { AddUserComponent } from "./modules/user-management/components/add-user/add-user.component";
import { ManageUserComponent } from "./modules/user-management/components/manage-user/manage-user.component";
import { UserDetailsComponent } from "./modules/user-management/components/user-details/user-details.component";

import { SettingsLoginAndPasswordComponent } from "./modules/settings/components/settings/settings-login-and-password/settings-login-and-password.component";
import { SettingsNotificationSettingsComponent } from "./modules/settings/components/settings/settings-notification-settings/settings-notification-settings.component";
import { SettingsUserProfileComponent } from "./modules/settings/components/settings/settings-user-profile/settings-user-profile.component";
import { SettingsComponent } from "./modules/settings/components/settings/settings.component";

import { SettingsConfigurationSettingsComponent } from "./modules/settings/components/settings/administration/settings-configuration-settings/settings-configuration-settings.component";

import { AddSitesComponent } from "./modules/site-management/components/add-site/add-site.component";
import { SiteDetailsComponent } from "./modules/site-management/components/site-details/site-details.component";
import { AddSponsorComponent } from "./modules/sponsor-management/components/add-sponsor/add-sponsor.component";
import { SponsorDetailsComponent } from "./modules/sponsor-management/components/sponsor-details/sponsor-details.component";
import { SettingsGeneralManagementSettingsComponent } from "./modules/settings/components/settings/administration/settings-general-management-settings/settings-general-management-settings.component";
import { ChangeReviewDetailsComponent } from "./modules/change-review/components/change-review-details/change-review-details.component";
import { ChangeReviewListComponent } from "./modules/change-review/components/change-review-list/change-review-list.component";
import { AuditLogsListComponent } from "./modules/audit-logs/components/audit-logs-list/audit-logs-list.component";
import { InvoicesComponent } from "./modules/invoice/components/invoices/invoices.component";
import { OrderSummaryReportComponent } from "./modules/reports/components/order-summary-report/order-summary-report.component";
import { OrderErpListComponent } from "./modules/order_erp/components/order_erp-list/order_erp-list.component";

export const routes: Routes = [
  { path: "", redirectTo: "auth/login", pathMatch: "full" },
  {
    path: "app",
    component: LayoutComponent,
    children: [
      {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [dashboardAccessGuard],
      },
      {
        path: "manage-users",
        children: [
          { path: "", component: ManageUserComponent },
          { path: "add-user", component: AddUserComponent },
          { path: "edit-user", component: AddUserComponent },
          { path: "user-details", component: UserDetailsComponent }
        ],
      },
      {
        path: "orders",
        children: [
          { path: "", component: OrdersListComponent },
          { path: "add-order", component: AddOrderComponent },
          { path: "order-details", component: OrderDetailsComponent },
        ],
      },
      {
        path: "products",
        children: [
          { path: "", component: ProductsListComponent },
          { path: "add-product", component: AddProductComponent },
          { path: "add-product/:id", component: AddProductComponent },
          { path: "product-details", component: ProductDetailsComponent },
          { path: "product-details/:id", component: ProductDetailsComponent },
        ],
      },
      {
        path: "order-erp",
        children: [
          { path: "", component: OrderErpListComponent },
          { path: "list", component: OrderErpListComponent },
        ],
      },
      {
        path: "trials",
        children: [
          { path: "", component: TrialsListComponent },
          { path: "add-trial", component: AddTrialComponent },
          { path: "add-trial/:id", component: AddTrialComponent },
          { path: "trial-details", component: TrialDetailsComponent },
          { path: "trial-details/:id", component: TrialDetailsComponent },
        ],
      },
      {
        path: "change-review",
        children: [
          { path: "", component: ChangeReviewListComponent },
          { path: "change-review-details", component: ChangeReviewDetailsComponent },
          { path: "change-review-details/:id", component: ChangeReviewDetailsComponent },
        ],
      },
      {
        path: "audit-logs",
        children: [
          { path: "", component: AuditLogsListComponent },
        ],
      },
      {
        path: "invoices",
        children: [
          { path: "", component: InvoicesComponent },
        ],
      },
      {
        path: "sites",
        children: [
          { path: "", component: SitesListComponent },
          { path: "add-site", component: AddSitesComponent },
          { path: "add-site/:id", component: AddSitesComponent },
          { path: "site-details", component: SiteDetailsComponent }
        ],
      },
      {
        path: "reports",
        children: [
          { path: "", redirectTo: "myob", pathMatch: "full" },
          {
            path: "myob",
            component: ReportsListComponent,
          },
          {
            path: "aksys",
            component: OrderSummaryReportComponent,
          }
        ],
      },
      {
        path: "sponsors",
        children: [
          { path: "", component: SponsorsListComponent },
          { path: "add-sponsor", component: AddSponsorComponent },
          { path: "sponsor-details", component: SponsorDetailsComponent }
        ],
      },
      {
        path: "settings",
        component: SettingsComponent,
        children: [
          { path: 'user-profile', component: SettingsUserProfileComponent },
          { path: 'notification-settings', component: SettingsNotificationSettingsComponent },
          { path: 'login-and-password', component: SettingsLoginAndPasswordComponent },
          { path: 'configuration-settings', component: SettingsConfigurationSettingsComponent },
          { path: 'general-order-management', component: SettingsGeneralManagementSettingsComponent },
        ]
      }
    ],
  },

  {
    path: "auth/login",
    loadComponent: () =>
      import("./pages/auth/login/login.component").then(
        (m) => m.LoginComponent
      ),
  },
  {
    path: "auth/admin-login",
    loadComponent: () =>
      import("./pages/auth/login/login.component").then(
        (m) => m.LoginComponent
      ),
  },
  {
    path: "auth/sys-login",
    loadComponent: () =>
      import("./pages/auth/login/login.component").then(
        (m) => m.LoginComponent
      ),
  },
  {
    path: "auth/forgot-password",
    loadComponent: () =>
      import("./pages/auth/forgot-password/forgot-password.component").then(
        (m) => m.ForgotPasswordComponent
      ),
  },
  {
    path: "auth/reset-password",
    loadComponent: () =>
      import("./pages/auth/reset-password/reset-password.component").then(
        (m) => m.ResetPasswordComponent
      ),
  },
  {
    path: "auth/tenant-settings",
    loadComponent: () =>
      import("./pages/auth/tenant-setting/tenant-setting.component").then(
        (m) => m.TenantSettingComponent
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule { }
